const _excluded = ["className", "destination", "children", "target", "onClick", "externalLinkAlternativeText", "externalLinkTitle", "variant", "isInline", "showLaunchIcon"];
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from 'react';
import classNames from 'classnames';
import isRequiredIf from 'react-proptype-conditional-require';
import { Launch } from '../../icons';
import Icon from '../Icon';
import withDeprecatedProps, { DeprTypes } from '../withDeprecatedProps';
export const HYPER_LINK_EXTERNAL_LINK_ALT_TEXT = 'in a new tab';
export const HYPER_LINK_EXTERNAL_LINK_TITLE = 'Opens in a new tab';
const Hyperlink = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
      className,
      destination,
      children,
      target,
      onClick,
      externalLinkAlternativeText,
      externalLinkTitle,
      variant,
      isInline,
      showLaunchIcon
    } = props,
    attrs = _objectWithoutProperties(props, _excluded);
  let externalLinkIcon;
  if (target === '_blank') {
    const generateRel = () => {
      let {
        rel
      } = attrs;
      if (!rel) {
        return 'noopener noreferrer';
      }
      if (!rel.includes('noopener')) {
        rel += ' noopener';
      }
      if (!rel.includes('noreferrer')) {
        rel += ' noreferrer';
      }
      return rel;
    };

    // Add this rel attribute to prevent Reverse Tabnabbing
    attrs.rel = generateRel();
    if (showLaunchIcon) {
      externalLinkIcon = /*#__PURE__*/React.createElement("span", {
        className: "pgn__hyperlink__external-icon",
        title: externalLinkTitle
      }, /*#__PURE__*/React.createElement(Icon, {
        src: Launch,
        screenReaderText: externalLinkAlternativeText,
        style: {
          height: '1em',
          width: '1em'
        }
      }));
    }
  }
  return /*#__PURE__*/React.createElement("a", _extends({
    ref: ref,
    className: classNames('pgn__hyperlink', `${variant}-link`, {
      'standalone-link': !isInline,
      'inline-link': isInline
    }, className),
    href: destination,
    target: target,
    onClick: onClick
  }, attrs), children, externalLinkIcon);
});
Hyperlink.defaultProps = {
  className: undefined,
  target: '_self',
  onClick: () => {},
  externalLinkAlternativeText: HYPER_LINK_EXTERNAL_LINK_ALT_TEXT,
  externalLinkTitle: HYPER_LINK_EXTERNAL_LINK_TITLE,
  variant: 'default',
  isInline: false,
  showLaunchIcon: true
};
export default withDeprecatedProps(Hyperlink, 'Hyperlink', {
  /** specifies the text or element that a URL should be associated with */
  content: {
    deprType: DeprTypes.MOVED,
    newName: 'children'
  }
});